/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { DateTime } from 'luxon';
export const DATE_ISO_FORMAT = 'yyyy-MM-dd';
export const DATE_US_FORMAT = 'MM/dd/yyyy';
export const DATE_US_SHORT_FORMAT = 'M/d/yyyy';
export const pastDateValidator = value => {
  if (!value) {
    // some date fields can be optional
    return;
  }
  const date = DateTime.fromFormat(value, DATE_US_FORMAT);
  return date <= DateTime.local() ? undefined : 'Date must be in the past';
};
export const futureDateValidator = value => {
  if (!value) {
    // some date fields can be optional
    return;
  }
  const date = DateTime.fromFormat(value, DATE_US_FORMAT);
  return date >= DateTime.local() ? undefined : 'Date must be in the future';
};